import { RootState } from '../../rootReducer';

export const appStatesSelectors = {
  getAppStates: (state: RootState) => state.AppStatesState.appStates,
};
